import {Injectable} from '@angular/core';
import {AuthenticationService} from '../Services/authentication.service';
import {Role} from '../Models/Role';
import {Helper} from '../../helpers/helper.service';
import * as _ from 'lodash';

export interface BadgeItem {
  type: string;
  value: string;
  icon?: string;
}

export interface ChildrenItems {
  route: string[];
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
  badge?: BadgeItem[];
}

export interface MainMenuItems {
  route: string[];
  short_label?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const BACKOFFICE_MENUITEMS = [
  {
    label: 'Main',
    main: [
      /*{
        route: ['/', 'back-office', 'dashboard'],
        short_label: 'D',
        name: 'menu.dashboard',
        type: 'link',
        icon: 'feather icon-home'
      },*/
      {
        route: ['/', 'back-office', 'Collections'],
        short_label: 'S',
        name: 'menu.collections',
        type: 'sub',
        icon: 'feather icon-grid',
        children: [

          {
            route: ['/', 'back-office', 'collection', 'overview'],
            name: 'menu.collections.overview'
          },
          {
            route: ['/', 'back-office', 'collection', 'archive'],
            name: 'menu.collections.archive'
          },
          {
            route: ['/', 'back-office', 'collection', 'add'],
            name: 'menu.collections.add'
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'D',
            name: 'menu.collections.models',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'model', 'overview'],
                name: 'menu.collections.models.overview'
              },
              {
                route: ['/', 'back-office', 'model', 'archive'],
                name: 'menu.collections.models.archive'
              },
              {
                route: ['/', 'back-office', 'model', 'add'],
                name: 'menu.collections.models.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'S',
            name: 'menu.collections.styles',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'style', 'overview'],
                name: 'menu.collections.styles.overview'
              },
              {
                route: ['/', 'back-office', 'style', 'archive'],
                name: 'menu.collections.styles.archive'
              },
              {
                route: ['/', 'back-office', 'style', 'add'],
                name: 'menu.collections.styles.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'D',
            name: 'menu.collections.products',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'product', 'overview'],
                name: 'menu.collections.products.overview'
              },
              {
                route: ['/', 'back-office', 'product', 'stock', 'overview'],
                name: 'menu.collections.products.stock.overview'
              },
              {
                route: ['/', 'back-office', 'product', 'archive'],
                name: 'menu.collections.products.archive'
              },
              {
                route: ['/', 'back-office', 'product', 'add'],
                name: 'menu.collections.products.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.parts',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'parts', 'overview'],
                name: 'menu.collections.parts.overview'
              },
              {
                route: ['/', 'back-office', 'parts', 'archive'],
                name: 'menu.collections.parts.archive'
              },
              {
                route: ['/', 'back-office', 'parts', 'add'],
                name: 'menu.collections.parts.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'fabric-collection'],
            short_label: 'F',
            name: 'menu.collections.fabric-collections',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'fabric-collection', 'overview'],
                name: 'menu.collections.fabric-collection.overview'
              },
              {
                route: ['/', 'back-office', 'fabric-collection', 'archive'],
                name: 'menu.collections.fabric-collection.archive'
              },
              {
                route: ['/', 'back-office', 'fabric-collection', 'add'],
                name: 'menu.collections.fabric-collection.add'
              },
              /*   {
                   route: ['/', 'back-office', 'fabric', 'add'],
                   name: 'menu.collections.fabric.add.description'
                 },*/
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'O',
            name: 'menu.collections.options',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'option', 'overview'],
                name: 'menu.collections.options.overview'
              },
              {
                route: ['/', 'back-office', 'option', 'archive'],
                name: 'menu.collections.options.archive.description'
              },
              {
                route: ['/', 'back-office', 'option', 'add'],
                name: 'menu.collections.options.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.properties',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'property', 'overview'],
                name: 'menu.collections.properties.overview'
              },
              {
                route: ['/', 'back-office', 'property', 'archive'],
                name: 'menu.collections.properties.archive'
              },
              {
                route: ['/', 'back-office', 'property', 'add'],
                name: 'menu.collections.properties.add'
              },
            ]
          },
        ]
      },
      {
        route: ['/', 'back-office', 'crm'],
        short_label: 'S',
        name: 'menu.crm',
        type: 'sub',
        icon: 'feather icon-user-check',
        children: [
          {
            route: ['/', 'back-office', 'crm', 'dealer', 'overview'],
            name: 'menu.crm.dealers.overview'
          },
          {
            route: ['/', 'back-office', 'crm', 'billing-accounts', 'overview'],
            name: 'menu.crm.billing-accounts.overview'
          },
          {
            route: ['/', 'back-office', 'exact-crm-updates', 'overview'],
            name: 'menu.exact_crm_updates',
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.suppliers',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'supplier', 'overview'],
                name: 'menu.collections.supplier.overview'
              },
              {
                route: ['/', 'back-office', 'supplier', 'archive'],
                name: 'menu.collections.supplier.archive'
              },
              {
                route: ['/', 'back-office', 'supplier', 'add'],
                name: 'menu.collections.suppliers.add'
              },
            ]
          },
        ]
      },
      {
        route: ['/', 'back-office', 'download'],
        short_label: 'S',
        name: 'menu.downloads',
        type: 'sub',
        icon: 'feather icon-download',
        children: [
          {
            route: ['/', 'back-office', 'download', 'overview'],
            name: 'menu.downloads.overview'
          },
          {
            route: ['/', 'back-office', 'download', 'add'],
            name: 'menu.downloads.add'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'orders', 'overview'],
        short_label: 'S',
        name: 'menu.backoffice.order.view',
        type: 'sub',
        icon: 'fa fa-truck ',
        children: [
          {
            route: ['/', 'back-office', 'order', 'overview'],
            name: 'menu.backoffice.order.view'
          },
          {
            route: ['/', 'back-office', 'quote', 'overview'],
            name: 'menu.backoffice.quote.urbansofa.view'
          },
          {
            route: ['/', 'back-office', 'packaging-label', 'overview'],
            name: 'menu.backoffice.packaging-label.overview'
          },
          {
            route: ['/', 'back-office', 'internal-packaging-label', 'overview'],
            name: 'menu.backoffice.internal-packaging-label.overview'
          },
          {
            route: ['/', 'back-office', 'order', 'pos', 'overview'],
            name: 'admin.pos.grid.title'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'invoice', 'overview'],
        short_label: 'S',
        name: 'menu.invoice.overview',
        type: 'sub',
        icon: 'fa fa-edit ',
        children: [
          {
            route: ['/', 'back-office', 'invoice', 'overview'],
            name: 'menu.invoice.overview'
          },
          {
            route: ['/', 'back-office', 'invoice', 'draft', 'overview'],
            name: 'menu.invoice.draft.overview'
          },
        ]
      },

      // TODO: Uncomment this if you want enable service request feature
      {
        route: ['/', 'back-office', 'service'],
        short_label: 'S',
        name: 'menu.service',
        type: 'sub',
        icon: 'feather icon-list',
        children: [
          {
            route: ['/', 'back-office', 'service', 'request', 'overview'],
            name: 'doctrine.service_request.overview.title'
          },
          {
            route: ['/', 'back-office', 'service', 'subject', 'overview'],
            name: 'menu.service.subject.overview'
          },
          {
            route: ['/', 'back-office', 'service', 'solution', 'overview'],
            name: 'admin.solution.overview.title'
          },
          {
            route: ['/', 'back-office', 'exchange'],
            name: 'menu.exchange'
          },
          {
            route: ['/', 'back-office', 'exchange-logs', 'overview'],
            name: 'menu.exchanges_logs',
          },
        ]
      },
      {
        route: ['/', 'back-office', 'settings', 'overview'],
        short_label: 'S',
        name: 'menu.settings',
        type: 'sub',
        icon: 'fa fa-cog ',
        children: [
          {
            route: ['/', 'back-office', 'emails'],
            short_label: 'E',
            name: 'menu.emails',
            type: 'sub',
            icon: 'feather icon-mail',
            children: [
              {
                route: ['/', 'back-office', 'emails', 'overview'],
                name: 'menu.emails.description'
              },
              {
                route: ['/', 'back-office', 'emails', 'log'],
                name: 'menu.emails.log'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'country'],
            short_label: 'L',
            name: 'menu.country',
            type: 'sub',
            icon: 'feather icon-globe',
            children: [
              {
                route: ['/', 'back-office', 'country', 'overview'],
                name: 'menu.country.overview'
              },
              {
                route: ['/', 'back-office', 'country', 'add'],
                name: 'menu.country.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'localization'],
            short_label: 'L',
            name: 'menu.languages',
            type: 'sub',
            icon: 'feather icon-type',
            children: [
              {
                route: ['/', 'back-office', 'localization', 'overview'],
                name: 'menu.languages.localization.overview'
              },
              {
                route: ['/', 'back-office', 'localization', 'languages'],
                name: 'menu.languages.language.overview'
              },
              {
                route: ['/', 'back-office', 'localization', 'label'],
                name: 'menu.languages.localization.label'
              },
              {
                route: ['/', 'back-office', 'localization', 'languages', 'add'],
                name: 'menu.languages.language.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'terms', 'overview'],
            short_label: 'T',
            name: 'menu.settings.terms',
            type: 'link',
          },
          {
            route: ['/', 'back-office', 'dealer-points'],
            short_label: 'E',
            name: 'menu.settings.dealer_point',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'dealer-dashboard', 'overview'],
            short_label: 'D',
            name: 'menu.dealer_dashboard_overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'invoice-layout', 'overview'],
            short_label: 'I',
            name: 'doctrine.invoice_layout.overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'dealer-profile', 'overview'],
            short_label: 'P',
            name: 'doctrine.dealer_profile.overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'invoice', 'draft', 'logs', 'overview'],
            name: 'menu.invoice.draft.logs'
          },
          {
            route: ['/', 'back-office', 'exact-logs', 'overview'],
            short_label: 'E',
            name: 'menu.exact_logs',
            type: 'link',
            icon: 'feather icon-mail'
          },
          {
            route: ['/', 'back-office', 'exact-retries', 'overview'],
            name: 'menu.exact_retries',
          },
          {
            route: ['/', 'back-office', 'disclaimer', 'overview'],
            name: 'menu.disclaimer',
          },
          {
            route: ['/', 'back-office', 'work-form-item', 'overview'],
            name: 'menu.work_form_item',
          },
        ]
      },
      {
        route: ['/', 'back-office', 'export'],
        short_label: 'E',
        name: 'menu.export',
        type: 'link',
        icon: 'fa fa-list-alt',
        children: [
          {
            route: ['/', 'back-office', 'export'],
            name: 'menu.export'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'account-setting'],
        short_label: 'E',
        name: 'menu.account_setting',
        type: 'link',
        icon: 'feather icon-users',
        children: [
          {
            route: ['/', 'back-office', 'account-setting'],
            name: 'menu.account_setting'
          },
        ]
      },
    ]
  }
];

const BACKOFFICE_SUPERADMIN_MENUITEMS = [
  {
    label: 'Main',
    main: [
      /*{
        route: ['/', 'back-office', 'dashboard'],
        short_label: 'D',
        name: 'menu.dashboard',
        type: 'link',
        icon: 'feather icon-home'
      },*/
      {
        route: ['/', 'back-office', 'Collections'],
        short_label: 'S',
        name: 'menu.collections',
        type: 'sub',
        icon: 'feather icon-grid',
        children: [

          {
            route: ['/', 'back-office', 'collection', 'overview'],
            name: 'menu.collections.overview'
          },
          {
            route: ['/', 'back-office', 'collection', 'archive'],
            name: 'menu.collections.archive'
          },
          {
            route: ['/', 'back-office', 'collection', 'add'],
            name: 'menu.collections.add'
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'D',
            name: 'menu.collections.models',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'model', 'overview'],
                name: 'menu.collections.models.overview'
              },
              {
                route: ['/', 'back-office', 'model', 'archive'],
                name: 'menu.collections.models.archive'
              },
              {
                route: ['/', 'back-office', 'model', 'add'],
                name: 'menu.collections.models.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'S',
            name: 'menu.collections.styles',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'style', 'overview'],
                name: 'menu.collections.styles.overview'
              },
              {
                route: ['/', 'back-office', 'style', 'archive'],
                name: 'menu.collections.styles.archive'
              },
              {
                route: ['/', 'back-office', 'style', 'add'],
                name: 'menu.collections.styles.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'D',
            name: 'menu.collections.products',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'product', 'overview'],
                name: 'menu.collections.products.overview'
              },
              {
                route: ['/', 'back-office', 'product', 'stock', 'overview'],
                name: 'menu.collections.products.stock.overview'
              },
              {
                route: ['/', 'back-office', 'product', 'archive'],
                name: 'menu.collections.products.archive'
              },
              {
                route: ['/', 'back-office', 'product', 'add'],
                name: 'menu.collections.products.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.parts',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'parts', 'overview'],
                name: 'menu.collections.parts.overview'
              },
              {
                route: ['/', 'back-office', 'parts', 'archive'],
                name: 'menu.collections.parts.archive'
              },
              {
                route: ['/', 'back-office', 'parts', 'add'],
                name: 'menu.collections.parts.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'fabric-collection'],
            short_label: 'F',
            name: 'menu.collections.fabric-collections',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'fabric-collection', 'overview'],
                name: 'menu.collections.fabric-collection.overview'
              },
              {
                route: ['/', 'back-office', 'fabric-collection', 'archive'],
                name: 'menu.collections.fabric-collection.archive'
              },
              {
                route: ['/', 'back-office', 'fabric-collection', 'add'],
                name: 'menu.collections.fabric-collection.add'
              },
              /*   {
                   route: ['/', 'back-office', 'fabric', 'add'],
                   name: 'menu.collections.fabric.add.description'
                 },*/
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'O',
            name: 'menu.collections.options',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'option', 'overview'],
                name: 'menu.collections.options.overview'
              },
              {
                route: ['/', 'back-office', 'option', 'archive'],
                name: 'menu.collections.options.archive.description'
              },
              {
                route: ['/', 'back-office', 'option', 'add'],
                name: 'menu.collections.options.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.properties',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'property', 'overview'],
                name: 'menu.collections.properties.overview'
              },
              {
                route: ['/', 'back-office', 'property', 'archive'],
                name: 'menu.collections.properties.archive'
              },
              {
                route: ['/', 'back-office', 'property', 'add'],
                name: 'menu.collections.properties.add'
              },
            ]
          },
        ]
      },
      {
        route: ['/', 'back-office', 'crm'],
        short_label: 'S',
        name: 'menu.crm',
        type: 'sub',
        icon: 'feather icon-user-check',
        children: [
          {
            route: ['/', 'back-office', 'crm', 'dealer', 'overview'],
            name: 'menu.crm.dealers.overview'
          },
          {
            route: ['/', 'back-office', 'crm', 'billing-accounts', 'overview'],
            name: 'menu.crm.billing-accounts.overview'
          },
          {
            route: ['/', 'back-office', 'exact-crm-updates', 'overview'],
            name: 'menu.exact_crm_updates'
          },
          {
            route: ['/', 'back-office', 'dashboard'],
            short_label: 'P',
            name: 'menu.collections.suppliers',
            type: 'sub',
            children: [
              {
                route: ['/', 'back-office', 'supplier', 'overview'],
                name: 'menu.collections.supplier.overview'
              },
              {
                route: ['/', 'back-office', 'supplier', 'archive'],
                name: 'menu.collections.supplier.archive'
              },
              {
                route: ['/', 'back-office', 'supplier', 'add'],
                name: 'menu.collections.suppliers.add'
              },
            ]
          },
        ]
      },
      {
        route: ['/', 'back-office', 'download'],
        short_label: 'S',
        name: 'menu.downloads',
        type: 'sub',
        icon: 'feather icon-download',
        children: [
          {
            route: ['/', 'back-office', 'download', 'overview'],
            name: 'menu.downloads.overview'
          },
          {
            route: ['/', 'back-office', 'download', 'add'],
            name: 'menu.downloads.add'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'orders', 'overview'],
        short_label: 'S',
        name: 'menu.backoffice.order.view',
        type: 'sub',
        icon: 'fa fa-truck ',
        children: [
          {
            route: ['/', 'back-office', 'order', 'overview'],
            name: 'menu.backoffice.order.view'
          },
          {
            route: ['/', 'back-office', 'quote', 'overview'],
            name: 'menu.backoffice.quote.view'
          },
          {
            route: ['/', 'back-office', 'packaging-label', 'overview'],
            name: 'menu.backoffice.packaging-label.overview'
          },
          {
            route: ['/', 'back-office', 'internal-packaging-label', 'overview'],
            name: 'menu.backoffice.internal-packaging-label.overview'
          },
          {
            route: ['/', 'back-office', 'order', 'pos', 'overview'],
            name: 'admin.pos.grid.title'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'invoice', 'overview'],
        short_label: 'S',
        name: 'menu.invoice.overview',
        type: 'sub',
        icon: 'fa fa-edit ',
        children: [
          {
            route: ['/', 'back-office', 'invoice', 'overview'],
            name: 'menu.invoice.overview'
          },
          {
            route: ['/', 'back-office', 'invoice', 'draft', 'overview'],
            name: 'menu.invoice.draft.overview'
          },
        ]
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        route: ['/', 'back-office', 'service'],
        short_label: 'S',
        name: 'menu.service',
        type: 'sub',
        icon: 'feather icon-list',
        children: [
          {
            route: ['/', 'back-office', 'service', 'request', 'overview'],
            name: 'doctrine.service_request.overview.title'
          },
          {
            route: ['/', 'back-office', 'service', 'subject', 'overview'],
            name: 'menu.service.subject.overview'
          },
          {
            route: ['/', 'back-office', 'service', 'solution', 'overview'],
            name: 'admin.solution.overview.title'
          },
{
            route: ['/', 'back-office', 'exchange'],
            name: 'menu.exchange'
          },
          {
            route: ['/', 'back-office', 'exchange-logs', 'overview'],
            name: 'menu.exchanges_logs',
          },
        ]
      },
      {
        route: ['/', 'back-office', 'settings', 'overview'],
        short_label: 'S',
        name: 'menu.settings',
        type: 'sub',
        icon: 'fa fa-cog ',
        children: [
          {
            route: ['/', 'back-office', 'emails'],
            short_label: 'E',
            name: 'menu.emails',
            type: 'sub',
            icon: 'feather icon-mail',
            children: [
              {
                route: ['/', 'back-office', 'emails', 'overview'],
                name: 'menu.emails.description'
              },
              {
                route: ['/', 'back-office', 'emails', 'log'],
                name: 'menu.emails.log'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'country'],
            short_label: 'L',
            name: 'menu.country',
            type: 'sub',
            icon: 'feather icon-globe',
            children: [
              {
                route: ['/', 'back-office', 'country', 'overview'],
                name: 'menu.country.overview'
              },
              {
                route: ['/', 'back-office', 'country', 'add'],
                name: 'menu.country.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'localization'],
            short_label: 'L',
            name: 'menu.languages',
            type: 'sub',
            icon: 'feather icon-type',
            children: [
              {
                route: ['/', 'back-office', 'localization', 'overview'],
                name: 'menu.languages.localization.overview'
              },
              {
                route: ['/', 'back-office', 'localization', 'languages'],
                name: 'menu.languages.language.overview'
              },
              {
                route: ['/', 'back-office', 'localization', 'label'],
                name: 'menu.languages.localization.label'
              },
              {
                route: ['/', 'back-office', 'localization', 'languages', 'add'],
                name: 'menu.languages.language.add'
              },
            ]
          },
          {
            route: ['/', 'back-office', 'terms', 'overview'],
            short_label: 'T',
            name: 'menu.settings.terms',
            type: 'link',
          },
          {
            route: ['/', 'back-office', 'dealer-points'],
            short_label: 'E',
            name: 'menu.settings.dealer_point',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'dealer-dashboard', 'overview'],
            short_label: 'D',
            name: 'menu.dealer_dashboard_overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'invoice-layout', 'overview'],
            short_label: 'I',
            name: 'doctrine.invoice_layout.overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'dealer-profile', 'overview'],
            short_label: 'P',
            name: 'doctrine.dealer_profile.overview',
            type: 'link'
          },
          {
            route: ['/', 'back-office', 'invoice', 'draft', 'logs', 'overview'],
            name: 'menu.invoice.draft.logs'
          },
          {
            route: ['/', 'back-office', 'exact-logs', 'overview'],
            short_label: 'E',
            name: 'menu.exact_logs',
            type: 'link',
            icon: 'feather icon-mail'
          },
          {
            route: ['/', 'back-office', 'exact-retries', 'overview'],
            name: 'menu.exact_retries',
          },
          {
            route: ['/', 'back-office', 'disclaimer', 'overview'],
            name: 'menu.disclaimer',
          },
          {
            route: ['/', 'back-office', 'work-form-item', 'overview'],
            name: 'menu.work_form_item',
          },
        ]
      },
      {
        route: ['/', 'back-office', 'system-user'],
        short_label: 'S',
        name: 'menu.system-users',
        type: 'sub',
        icon: 'feather icon-users',
        children: [
          {
            route: ['/', 'back-office', 'system-user', 'overview'],
            name: 'menu.system-users.overview'
          },
          {
            route: ['/', 'back-office', 'system-user', 'add'],
            name: 'menu.system-users.add'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'export'],
        short_label: 'E',
        name: 'menu.export',
        type: 'link',
        icon: 'fa fa-list-alt',
        children: [
          {
            route: ['/', 'back-office', 'export'],
            name: 'menu.export'
          },
        ]
      },
      {
        route: ['/', 'back-office', 'account-setting'],
        short_label: 'E',
        name: 'menu.account_setting',
        type: 'link',
        icon: 'feather icon-users',
        children: [
          {
            route: ['/', 'back-office', 'account-setting'],
            name: 'menu.account_setting'
          },
        ]
      },
    ]
  }
];

const DEALER_MENUITEMS = [
  {
    label: 'Main',
    main: [
      {
        route: ['/', 'dealer-system', 'dashboard'],
        short_label: 'D',
        name: 'menu.dashboard',
        type: 'link',
        icon: 'feather icon-home'
      },
      {
        route: ['/', 'dealer-system', 'order', 'add'],
        short_label: 'D',
        name: 'menu.place_order',
        type: 'link',
        icon: 'fa fa-shopping-cart'
      },
      {
        route: ['/', 'dealer-system', 'order', 'overview'],
        short_label: 'O',
        name: 'menu.place_order.overview',
        type: 'link',
        icon: 'fa fa-truck'
      },
      {
        route: ['/', 'dealer-system', 'quote', 'overview'],
        short_label: 'O',
        name: 'menu.place_quote.overview',
        type: 'link',
        icon: 'fa fa-th-list'
      },
      {
        route: ['/', 'dealer-system', 'invoice', 'overview'],
        short_label: 'O',
        name: 'menu.invoices',
        type: 'link',
        icon: 'fa fa-edit'
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        route: ['/', 'dealer-system', 'service', 'overview'],
        short_label: 'O',
        name: 'menu.services',
        type: 'sub',
        icon: 'fa fa-list',
        children: [
          {
            route: ['/', 'dealer-system', 'service', 'overview'],
            name: 'menu.services'
          },
          {
            route: ['/', 'dealer-system', 'exchange'],
            name: 'menu.exchange'
          },
          {
            route: ['/', 'dealer-system', 'service-request', 'add'],
            name: 'admin.service.request.view.title'
          },
        ]
      },
      {
        route: ['/', 'dealer-system', 'download', 'overview'],
        short_label: 'O',
        name: 'menu.downloads',
        type: 'link',
        icon: 'feather icon-download'
      },
      {
        route: ['/', 'dealer-system', 'account', 'overview'],
        short_label: 'O',
        name: 'menu.my_accounts',
        type: 'link',
        icon: 'feather icon-users'
      },
    ]
  }
];

const User_MENUITEMS = [
  {
    label: 'Main',
    main: [
      {
        route: ['/', 'dealer-system', 'dashboard'],
        short_label: 'D',
        name: 'menu.dashboard',
        type: 'link',
        icon: 'feather icon-home'
      },
      {
        route: ['/', 'dealer-system', 'order', 'add'],
        short_label: 'D',
        name: 'menu.place_order',
        type: 'link',
        icon: 'fa fa-shopping-cart'
      },
      {
        route: ['/', 'dealer-system', 'order', 'overview'],
        short_label: 'O',
        name: 'menu.place_order.overview',
        type: 'link',
        icon: 'fa fa-truck'
      },
      {
        route: ['/', 'dealer-system', 'quote', 'overview'],
        short_label: 'O',
        name: 'menu.place_quote.overview',
        type: 'link',
        icon: 'fa fa-th-list'
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        route: ['/', 'dealer-system', 'service', 'overview'],
        short_label: 'O',
        name: 'menu.services',
        type: 'sub',
        icon: 'fa fa-list',
        children: [
          {
            route: ['/', 'dealer-system', 'service', 'overview'],
            name: 'menu.services'
          },
          {
            route: ['/', 'dealer-system', 'exchange'],
            name: 'menu.exchange',
          },
          {
            route: ['/', 'dealer-system', 'service-request', 'add'],
            name: 'admin.service.request.view.title'
          },
        ]
      },
      {
        route: ['/', 'dealer-system', 'download', 'overview'],
        short_label: 'O',
        name: 'menu.downloads',
        type: 'link',
        icon: 'feather icon-download'
      },
      {
        route: ['/', 'dealer-system', 'account', 'overview'],
        short_label: 'O',
        name: 'menu.my_accounts',
        type: 'link',
        icon: 'feather icon-users'
      },
    ]
  }
];

const Tablet_MENUITEMS = [
  {
    label: 'Main',
    main: [
      {
        route: ['/', 'dealer-system', 'quote', 'overview'],
        short_label: 'O',
        name: 'menu.place_quote.overview',
        type: 'link',
        icon: 'fa fa-th-list'
      },
    ]
  }
];

@Injectable()
export class MenuItems {
  private type: string|null = null;
  private menu: Menu[];
  private resolve: Function|null = null;
  private onHoldItems = [
    'menu.place_order',
    'menu.place_order.overview',
    'menu.place_quote.overview',
    'menu.downloads',
    'menu.my_accounts',
  ];

  constructor(private auth: AuthenticationService) {
  }

  getAll(): Promise<Menu[]> {
    return new Promise<Menu[]>((resolve) => {
      this.resolve = resolve;
      resolve(this.getMenuItems());
    });
  }

  getMenuItems(): Menu[] {
    if (this.auth.getRole() === Role.ROLE_DEALER && this.auth.isDealerUser()) {
      return (this.auth.getRole() === Role.ROLE_BACK_OFFICE) ? this.getBackofficeMenuItems() : User_MENUITEMS;
    } else if (this.auth.getRole() === Role.ROLE_DEALER && this.auth.isDealerTabletUser()) {
      return (this.auth.getRole() === Role.ROLE_BACK_OFFICE) ? this.getBackofficeMenuItems() : Tablet_MENUITEMS;
    } else {
      if (this.auth.isBackofficeSuperadmin()) {
        return this.getBackofficeSuperAdminMenuItems();
      } else {
        return (this.auth.getRole() === Role.ROLE_BACK_OFFICE) ? this.getBackofficeMenuItems() : this.getDealerMenuItems();
      }
    }
  }

  getBackofficeMenuItems(): any[] {
    this.type = 'backoffice';
    return this.menu = BACKOFFICE_MENUITEMS;
  }

  getBackofficeSuperAdminMenuItems(): any[] {
    this.type = 'backoffice';
    return this.menu = BACKOFFICE_SUPERADMIN_MENUITEMS;
  }

  getDealerMenuItems(): any[] {
    this.type = 'dealer';
    return this.menu = DEALER_MENUITEMS;
  }

  private normalizeServiceNotificationBadgePayload(value: any): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    if (typeof value === 'boolean') {
      return null;
    }
    if (typeof value === 'number') {
      if (isNaN(value) || value <= 0) {
        return null;
      }
      return String(Math.floor(value));
    }
    if (typeof value === 'string') {
      const t = value.trim();
      if (t === '' || t === '0') {
        return null;
      }
      return t;
    }
    if (typeof value === 'object') {
      const keys = [
        'count',
        'notificationsCount',
        'notifications_count',
        'notifications',
        'total',
        'items',
        'data'
      ];
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const nested = this.normalizeServiceNotificationBadgePayload(value[key]);
          if (nested !== null) {
            return nested;
          }
        }
      }
    }
    return null;
  }

  setServiceBadge(value: any) {
    if (!this.menu || !this.menu[0] || !this.menu[0].main) {
      return;
    }
    const serviceMenuName = this.type === 'dealer' ? 'menu.services' : 'menu.service';
    const mainItem = this.menu[0].main.find((m: MainMenuItems) => m.name === serviceMenuName);
    if (!mainItem) {
      return;
    }
    const display = this.normalizeServiceNotificationBadgePayload(value);
    if (display) {
      mainItem.badge = <BadgeItem[]>[
        {
          type: 'success',
          value: display
        }
      ];
    } else {
      delete mainItem.badge;
    }
    this.getAll().then(() => {
      this.resolve(this.menu);
    });
  }

  setInvoiceDraftBadge(total: number) {
    if (!this.menu?.[0]?.main) {
      return;
    }
    const mainItem = this.menu[0].main.find((m: MainMenuItems) => m.name === 'menu.invoice.overview');
    if (!mainItem) {
      return;
    }
    const n = Math.floor(Number(total));
    if (!isNaN(n) && n > 0) {
      mainItem.badge = <BadgeItem[]>[
        {
          type: 'success',
          value: String(n)
        }
      ];
    } else {
      delete mainItem.badge;
    }
    this.getAll().then(() => {
      this.resolve(this.menu);
    });
  }

  isDisable(name: string) {
    return (this.auth.getRole() !== Role.ROLE_BACK_OFFICE &&  this.auth.getStatus() === 'on_hold') && this.onHoldItems.includes(name);
  }

  setBadge(value: any, menuItemName: string) {
    if (!Helper.isDefined(this.menu) || !Helper.isDefined(this.menu[0]) || !Helper.isDefined(this.menu[0].main[2])) {
      return;
    }
    const menuItem = this.findMenuItem(menuItemName);
    if (value && value !== '0' && menuItem) {
      this.findMenuItem(menuItemName).badge = <BadgeItem[]>[
        {
          type: 'success',
          value: value
        }
      ];
    } else if (menuItem) {
      delete menuItem.badge;
    }
    this.updateMainMenuItemsBadge();
    this.getAll().then(() => {
      this.resolve(this.menu);
    });
  }

  updateMainMenuItemsBadge() {
    this.getMenuItems()[0].main.map(menuItem => {
      let badgeCounter = 0;
      menuItem.children.forEach(childMenu => {
        if (childMenu.badge && childMenu.badge.length > 0) {
          badgeCounter++;
        }
      });
      // If a child menu item has badge, parent item should have a badge too
      if (badgeCounter > 0) {
        menuItem.badge = <BadgeItem[]>[
          {
            type: 'success',
            value: '',
            icon: 'fa fa-bell'
          }
        ];
      }
    });
  }

  findMenuItem(name: string) {
    return _.find(_.flatten(this.getMenuItems()[0].main.map(parentMenu => parentMenu.children)), menuItem => menuItem.name === name);
  }
}
